/*
 * `--pf` объявлено ЧЕРЕЗ `@property`, а не просто передано инлайном, и причина не в красоте.
 * Значение приходит С СЕРВЕРА; окажись там не цвет, обычная кастомная переменная сделала бы
 * `color-mix` «невалидным на этапе вычисления», и фон бейджа молча стал бы прозрачным — то есть
 * поломка выглядела бы как оформление. С объявленным синтаксисом негодное значение откатывается к
 * `initial-value`, и бейдж остаётся нейтральным, но целым.
 *
 * ⚠️ Движки без `@property` правило просто игнорируют — хуже не делают. Проверено только в
 * Chromium: харнесс берёт установленный браузер, а установлены тут только Chromium-движки.
 * Утверждать про остальные нечем.
 */
@property --pf {
  syntax: '<color>';
  initial-value: transparent;
  inherits: false;
}

.root {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 2px 7px;
  border: 1px solid color-mix(in oklch, var(--pf) 34%, var(--line));
  border-radius: 5px;
  /*
   * ⚠️ ДОЛЯ МАЛА НАМЕРЕННО. `color-mix` линеен по светлоте, поэтому при 14% светлота результата
   * лежит между 0.14·L(цвет) и 0.86·L(подложка) + 0.14 — то есть далеко от подложки не уходит ни
   * при каком входе. Отсюда и берётся гарантия читаемости чернил поверх: она не «обычно
   * выполняется», а следует из арифметики смешивания. Крайние случаи (чёрный и белый с сервера)
   * посчитаны контраст-гейтом.
   */
  background: color-mix(in oklch, var(--pf) 14%, var(--tint-on));
  font-size: 10.5px;
  font-weight: 600;
  /* Чернила НАШИ, не серверные: цвет текста — единственное место, где чужое значение сделало бы
     читаемость непроверяемой. */
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
}

/*
 * ⚠️ ИМЯ — В СВОЁМ БЛОКЕ, И ЭТО НЕ ЛИШНЯЯ ОБЁРТКА. `text-overflow` работает только на блочном
 * контейнере с текстом ВНУТРИ него; у `inline-flex` текст лежит в анонимном flex-элементе, и
 * многоточие не рисуется вовсе — строка просто обрубается по краю. На скриншоте это выглядело как
 * «RealtyCalenda» и «Импортирова»: обрезано посреди слова и без единого признака, что там есть
 * продолжение. Зонд об этом не спрашивали — он проверял ТЕКСТ, а текст был целым.
 */
.name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
